import isEqual from "lodash.isequal";
// eslint-disable-next-line import/prefer-default-export
export const isEqualPreviousBuilder = () => {
  let oldVal: any;
  return function isEqualPrev(currentVal: any): boolean {
    const isEqualValue: boolean = isEqual(currentVal, oldVal);
    oldVal = currentVal;
    return isEqualValue;
  };
};
